// the one Highcharts instance for the app: import it from here so every chart gets these modules and defaults
import Highcharts from 'highcharts/highstock';
import 'highcharts/highcharts-more';
import 'highcharts/modules/exporting';
import 'highcharts/modules/export-data';
import 'highcharts/modules/accessibility';
import { applyHighchartsLang, subscribeHighchartsLang } from 'highcharts-lang';

const prefersReducedMotion =
    typeof window !== 'undefined' && !!window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;

// global for all charts, but can be overridden by individual chart instances
Highcharts.setOptions({
    // highcharts 13 added a palette that follows the OS colour scheme by default
    // we need to force it to light for now because we don't support themeing yet
    palette: {
        colorScheme: 'light',
    },
    accessibility: {
        enabled: true,
        keyboardNavigation: {
            enabled: true,
        },
    },
    // load exporting so screen readers see 'view as data table' link but disable it so that the button doesnt appear on charts
    exporting: {
        enabled: false,
    },
    // WCAG 1.4.13: the pointer can move onto the tooltip; the accessibility module already hides tooltips on Escape
    tooltip: {
        stickOnContact: true,
    },
    // WCAG 2.3.3: no draw-in animation when the OS asks for reduced motion
    ...(prefersReducedMotion ? { chart: { animation: false }, plotOptions: { series: { animation: false } } } : {}),
});

// Highcharts' own strings and dates in the app language (numbers stay English), published by HighchartsLocale
subscribeHighchartsLang((lang) => applyHighchartsLang(Highcharts, lang));

export default Highcharts;
